<script setup>
import { computed, ref } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  approval: { type: Object, required: true },
});
const emit = defineEmits(['decide']);

const isSubmitting = ref(false);

const riskLabel = computed(() =>
  props.approval.risk === 'high'
    ? 'Ação de ALTO risco'
    : 'Ação que altera o ambiente'
);

const prettyArgs = computed(() => {
  const { args } = props.approval;
  if (!args) return '';
  if (typeof args === 'string') return args;
  try {
    return JSON.stringify(args, null, 2);
  } catch (e) {
    return String(args);
  }
});

const decide = (approved, always = false) => {
  if (isSubmitting.value) return;
  isSubmitting.value = true;
  emit('decide', { approved, always });
};
</script>

<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<template>
  <div
    class="rounded-lg border p-3 space-y-2"
    :class="
      approval.risk === 'high'
        ? 'border-n-ruby-8 bg-n-ruby-2'
        : 'border-n-amber-8 bg-n-amber-2'
    "
  >
    <div class="flex items-start gap-2">
      <Icon
        icon="i-lucide-shield-alert"
        class="w-4 h-4 mt-0.5 flex-shrink-0"
        :class="approval.risk === 'high' ? 'text-n-ruby-11' : 'text-n-amber-11'"
      />
      <div class="flex-1 min-w-0">
        <div class="text-sm font-medium text-n-slate-12">
          {{ approval.label }}
        </div>
        <div class="text-xs text-n-slate-11">
          {{ riskLabel }} · {{ approval.name }}
          <span v-if="approval.server"> ({{ approval.server }})</span>
        </div>
      </div>
    </div>
    <pre
      v-if="prettyArgs"
      class="text-xs bg-n-solid-2 rounded p-2 overflow-x-auto whitespace-pre-wrap break-all text-n-slate-11 max-h-40"
      >{{ prettyArgs }}</pre
    >
    <div class="flex flex-wrap gap-2">
      <Button
        label="Autorizar"
        icon="i-lucide-shield-check"
        teal
        sm
        :disabled="isSubmitting"
        @click="decide(true)"
      />
      <Button
        v-if="approval.risk !== 'high'"
        label="Autorizar sempre nesta execução"
        faded
        slate
        sm
        :disabled="isSubmitting"
        @click="decide(true, true)"
      />
      <Button
        label="Recusar"
        icon="i-lucide-ban"
        ghost
        ruby
        sm
        :disabled="isSubmitting"
        @click="decide(false)"
      />
    </div>
  </div>
</template>
